import { render } from "./legal-notice.vue?vue&type=template&id=5e74bc63&scoped=true&lang=html"
import script from "./legal-notice.vue?vue&type=script&lang=js"
export * from "./legal-notice.vue?vue&type=script&lang=js"

import "./legal-notice.vue?vue&type=style&index=0&id=5e74bc63&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e74bc63"]])

export default __exports__